import type { ApiClientOptions } from "./client"
import { createApiClient } from "./client"
import type { ModelCatalogEntry } from "@/lib/types/model-catalog"

export function createModelsApi(options: ApiClientOptions) {
  const api = createApiClient(options)

  return {
    list: (category?: string): Promise<ModelCatalogEntry[]> => {
      const qs = category ? `?category=${encodeURIComponent(category)}` : ""
      return api.get<ModelCatalogEntry[]>(`/api/models${qs}`)
    },
  }
}
